angular.module('jv.Admin.Users')
    .controller('jvAdminUsersMessageModalController', ['$scope', function($scope){
        $scope.hideModal = function() {
            $scope.messageModal.show = false;
        };
    }]);